console.log("init Proteus Treatments 1.07")

//
// START PP Logic
//

const push_pp_offers = () => {
  if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

    // window.cart_pp_offers = [];
    if(window.location.href.indexOf("new_pp") > -1){
      window.cart_pp_offers = window.cart_pp_offers_new
    }

    const hasNormalItem = cart_data.items.some(item => {
      const p = item.properties || {};

      const isPre_or_membership =
        "_shipping" in p ||
        "_pre-sale" in p ||
        "_pre-order" in p ||
        "_pre_sale" in p ||
        "_pre_order" in p;

      return !isPre_or_membership;
    });

    let offers_to_push = window.cart_pp_offers;

    if(!hasNormalItem){
      offers_to_push = [];
    } 

    let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
    fetch("https://proteus-super7.fly.dev/api/pp_offers", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
        referenceId: session_id,
        offers: offers_to_push
      })
    }).then(res => res.json()).then(console.log).catch(console.error);

  }
};

waitUntil(() => {
  return typeof window.cart_pp_offers != "undefined" && window.cart_pp_offers.length > 0;
}).then(() => {

  if(!window.sessionStorage.getItem("Proteus pp-session-id")){
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}).catch();

// this call needs to also grab the defaults (server-side)
async function get_proteus_product_data(prod_ids) {

  // const default_ids = "7250270716037" // csv of ids -- mystery t
  let default_ids = "7188980924549" // csv of ids -- Mystery ReAction Figure - Movies & TV
  let activation_attr = "[SUP7-86]v0"
  if(window.sessionStorage.getItem("[SUP7-86]v1 active")){
    default_ids = "7306340565125"; // mystery FUN! FUN!
    activation_attr = "[SUP7-86]v1"
  }
  gtm_add_cartAttribute("proteus_checkout_upsell", activation_attr)

  const ids_csv = [
    ...(prod_ids ? prod_ids.split(',') : []),
    default_ids
  ].join(',');

  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-super7.fly.dev/api/catalog?lookup=product_offers&ids=${ids_csv}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

// document.addEventListener("cart:change", async (e) => {
document.addEventListener("proteus:cart-changed", async (e) => {

  console.log("proteus:cart updated", e.detail);

  window.cart_data = e.detail;

  // add.js returns a line item instead of full cart
  if (!window.cart_data?.items) {
    try {
      const res = await fetch("/cart.js");
      window.cart_data = await res.json();
    } catch (err) {
      console.error("failed to normalize cart", err);
      return;
    }
  }

  let cart_prod_ids = [];
  for(let i = 0; i < cart_data.items.length; i++){
    cart_prod_ids.push(cart_data.items[i].product_id);
  }

  get_proteus_product_data(cart_prod_ids.toString()).then(response => {
    console.log("get_proteus_product_data", response)
    window.staged_pp_offers = response.offers;
    
    window.cart_pp_offers = [];

    for (let i = 0; i < window.staged_pp_offers.length; i++) {
      const s = window.staged_pp_offers[i];

      if (!window.cart_pp_offers.some(o => o.pp_offer_id === s.def_offer_id)) {
        window.cart_pp_offers.push({
          pp_offer_type: s.def_type,
          pp_offer_new_qty: s.def_quantity,
          pp_offer_new_interval: s.ref_new_interval,
          pp_offer_id: s.def_offer_id,
          pp_offer_variants: s.ref_line_vars,
          pp_offer_banner_title: s.content_banner_title,
          pp_offer_banner_subtitle: s.content_banner_subtitle,
          pp_offer_title: s.content_title,
          pp_offer_image_url: s.content_images[0],
          pp_offer_description: [s.content_description],
          pp_offer_compare_at: s.content_compare_at,
          pp_offer_price: s.content_offer_price,
          changes: s.changes,
        });
      }
    }

    push_pp_offers();
  
  });

});

//
// END PP Logic
//

// support for FUN! FUN! free shipping
observeSelector('form[data-product-tags*="fun! fun!"]', fun_fun_form => {
  fun_fun_form.insertAdjacentHTML("beforeend", `<input type="hidden" name="properties[_shipping]" value="FUN! FUN!">`)
});

observeSelector('form[data-licence-handle][data-licence-wave]', atc_form_w_license => {
  let licence_handle = atc_form_w_license.getAttribute("data-licence-handle");
  let licence_wave = atc_form_w_license.getAttribute("data-licence-wave");
  atc_form_w_license.insertAdjacentHTML("beforeend", `<input type="hidden" name="properties[_info_1]" value="licence: ${licence_handle}">`)
  atc_form_w_license.insertAdjacentHTML("beforeend", `<input type="hidden" name="properties[_info_2]" value="wave: ${licence_wave}">`)
  atc_form_w_license.insertAdjacentHTML("beforeend", `<input type="hidden" name="properties[_discount]" value="${licence_wave} ${licence_handle}">`)
});

// START support for [SUP7-65]
if(window.sessionStorage.getItem("[SUP7-65] new wave discount logic") || window.location.href.indexOf("new_wave_logic") > -1){
  window.sessionStorage.setItem("[SUP7-65] new wave discount logic", true);
  waitUntil(() => {
    return typeof window.cart_data != "undefined";
  }).then(() => {

    let is_updating_cart = false;
    let last_discount_value = window.cart_data.attributes?._discount || "";

    let set_discount_attr = (val) => {

      console.log("set_discount_attr()")

      // prevent unnecessary updates or reentrance
      if (is_updating_cart || val === last_discount_value) return;

      is_updating_cart = true;
      last_discount_value = val;

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { _discount: val } }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Cart attribute set:", data.attributes);
          document.dispatchEvent(new Event("cart:refresh"));
        })
        .catch((err) => console.error("Error updating cart:", err))
        .finally(() => {
          // wait for Shopify to finish re-rendering before re-enabling
          setTimeout(() => (is_updating_cart = false), 1000);
        });
    };

    let review_cart_data = () => {
      if (is_updating_cart) return;

      console.log("review_cart_data()...");
      let new_wave_in_cart = false;

      for (let i = 0; i < cart_data.items.length; i++) {
        const item = cart_data.items[i];

        console.log(item.properties["_discount"])

        // if (item.properties["_discount"] === "new thundercats") {
        if (item.properties["_discount"].indexOf("new") > -1) {
          new_wave_in_cart = true;
          if (cart_data.attributes?._discount !== "[SUP7-65] v1 -- new wave") {
            set_discount_attr("[SUP7-65] v1 -- new wave");
          }
          break;
        }

        if (i === cart_data.items.length - 1 && !new_wave_in_cart) {
          if (cart_data.attributes?._discount === "[SUP7-65] v1 -- new wave") {
            set_discount_attr("none");
          }
        }
      }
    };

    // init
    setTimeout(() => {
      review_cart_data();
    }, 3500)

    observeSelector('line-item', line_item => {
      review_cart_data();
    });

  }).catch();

}
// END support for [SUP7-65]

// patch
// observeSelector('price-list', price_list => {
//     price_list.setAttribute("style", "display: flex !important;");
// })

// handling hidden items
observeSelector('product-card[data-product-tags*="hidden"], .horizontal-product[data-product-tags*="hidden"]', hidden_product_el => {
  console.log(`removed product-card[handle="${hidden_product_el.getAttribute("handle")}"]`);
  hidden_product_el.remove()
});

if(window.location.href.indexOf("sort_by=") == -1 && window.location.href.indexOf("/collections/") > -1){
  waitForElement('button[value="created-descending"]:not([aria-selected="true"]').then(sort_btn => {
    setTimeout(() => {
      console.log("default to created-descending");
      sort_btn.click();
    }, 250)
  }).catch();
}

// support for OOS filters
observeSelector('input[name="filter.v.availability"]', oos_toggle => {
  oos_toggle.addEventListener("change", (e) => {});
});

observeSelector('.collection__results', filter_results => {
  if(window.location.href.indexOf("filter.v.availability=1") > -1){
    waitForElement('body').then(doc => {
      doc.insertAdjacentHTML("afterbegin", `
      <style>
        /* adjust order so lazy load will activate */
        .collection__results[data-show-oos="false"] product-card{
          order: 5;
        }
        .collection__results[data-show-oos="false"] product-card[data-product-tags*="napa-oos"]{
          display: none;
          order: 1; 
        }
      </style>
      `);
    }).catch();
    
    filter_results.setAttribute("data-show-oos", false);

  } else {
    filter_results.setAttribute("data-show-oos", true);
  }
  
});

/*
Tariff Surcharge App

CART ATTRIBUTES:

"_tariff_application":
  - (unset): if not present or is an invalid value, nothing is applied
  - "global" (default): a single item is added to the cart, line item property added to each item
  - "global_quiet": a single item is added to the cart, NO LINE ITEM PROP IS ADDED
  - "line": each applicable line_item price is increased with line_item property added
  - "line_quiet": each applicable line_item price is increased, NO LINE ITEM PROP IS ADDED (intended for cart content block)

"_tariff_percentage":
  - a number 0 - 100 which is converted into a multiplier
  - eg. "8" = 8% = *1.08

"_tariff_title":
  - (default) "[tariff_percentage]% Tariff" 
  - a string (eg. "8% Tariff" or "Tariff") that will be used in line_item properties and global tariff product title
  - eg. "8% Tariff: $55.02"
  - eg. "8% Tariff is charged on [applicable cart qty] item(s)"

---

LINE ITEM PROPERTIES:

+ _tariff_percentage:
  - if set, it will override the cart attribute's tariff_percentage
  - a number 0 - 100 which is converted into a multiplier
  - eg. "15" = 15% = *1.15
  - if "0" then this item will be exempt

APPLYING PROPERTIES

most-performant to add them at ATC (as opposed to observing the cart via add_line_props_by_handle()) so we do both
*/

/*
let tariff_application = "global";
let tariff_percentage = "8";
let tariff_title = "Tariff Charge";
let tariff_var_id = "41200150118533";

if(window.location.href.indexOf("/products/tariff-fee") > -1 ||
window.location.href.indexOf(tariff_var_id) > -1){
  window.location.href = "/";  
}

waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
    <style>
    cart-drawer .cart-drawer__line-items{
      display: flex;
      flex-wrap: wrap;
    }
    cart-drawer .cart-drawer__line-items line-item{
      order: 1;
      width: 100%;
    }
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"]{
      order: 999;
      padding: .5rem !important;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #ddd;
      font-size: 11px;
      margin-top: 2rem;
      font-weight: bold;
      pointer-events: none;
    }
    line-item[data-var-id="${tariff_var_id}"] a{
      pointer-events: none;
    }
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"] .line-item__info{
      width: 100%;
      position: relative;
      padding-left: 55px;
    }
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"] .line-item__info:before{
      content: "";
      display: block;
      position: absolute;
      top: 0; 
      left: 0;
      width: 55px;
      height: 1.5em;
      background: url(//super7.com/cdn/shop/files/2025_Super7_LogoFC.png?v=1749736775&width=829) center center no-repeat;
      background-size: contain;
    }
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"] > *:not(.line-item__info),
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"] .line-item__info > *{
      display: none;
    }
    cart-drawer .cart-drawer__line-items line-item[data-var-id="${tariff_var_id}"] .line-item__info > div:first-child{
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    </style>
  `);
}).catch();

// ATC form
let is_exempt_pdp = false;
observeSelector('form[action="/cart/add"][data-product-tags]', atc_form => {
  if(atc_form.getAttribute("data-product-tags").indexOf("apparel") > -1 ||
    atc_form.getAttribute("data-product-tags").indexOf("gift card") > -1 ||
    atc_form.getAttribute("data-product-tags").indexOf("enamel pins") > -1  
  ){
    
    if(!!atc_form.closest('.shopify-section--main-product')){
      is_exempt_pdp = true; 
    }
    
    atc_form.insertAdjacentHTML("afterbegin", `
      <input type="hidden" name="properties[_tariff_percentage]" value="0" />
    `);
  } else {
    atc_form.insertAdjacentHTML("afterbegin", `
      <input type="hidden" name="properties[_tariff_percentage]" value="${tariff_percentage}" />
      <input type="hidden" name="properties[Tariff]" value="${tariff_percentage}%" />
    `);
    waitForElement('.product-info__payment-terms').then(payment_terms => {
      if(document.querySelectorAll('.js-tariff-message').length == 0 && !is_exempt_pdp){

        payment_terms.insertAdjacentHTML("afterend", `
          <div style="margin-top: 1.5rem;" class="js-tariff-message">*This product is subject to an ${tariff_percentage}% tariff fee. <a href="https://super7.com/pages/faq#faq-question_CYQcNt" target="_blank" style="text-decoration:underline;">Learn more</a>.</div>
        `);
        
      }
    }).catch();
  }
});
*/

/*
// remove tariff props
async function strip_cart_props() {
  try {
    // 1. Get the latest cart
    const res = await fetch("/cart.js");
    const cart = await res.json();

    if (!cart.items.length) {
      console.log("Cart is empty, nothing to strip.");
      return;
    }

    // 2. Rebuild items with properties minus "mystery"
    const cleanItems = cart.items.map(item => {
      // copy properties except those with key "mystery"
      const newProps = {};
      if (item.properties) {
        for (const [key, value] of Object.entries(item.properties)) {
          if (key !== "Tariff") {
            newProps[key] = value;
          }
        }
      }

      return {
        id: item.variant_id,
        quantity: item.quantity,
        ...(Object.keys(newProps).length ? { properties: newProps } : {})
      };
    });

    // 3. Clear the cart
    await fetch("/cart/clear.js", { method: "POST" });

    // 4. Add back cleaned items
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: cleanItems })
    });

    console.log("Cart rebuilt without 'mystery' properties:", cleanItems);
    document.dispatchEvent(new CustomEvent("cart:refresh"));

  } catch (err) {
    console.error("Error stripping cart properties:", err);
  }
}

setTimeout(() => {
  strip_cart_props();
}, 2500)
*/

// remove tariff item if it is cached in there
const tariff_var_id = 41200150118533; 

fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {

      console.log("cart", cart)
      
    const line = cart.items.find(item => item.variant_id === tariff_var_id);
    if (!line) {
      console.log('Variant not in cart');
      return;
    }

    // Remove by line key
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: line.key, // line identifier
        quantity: 0
      })
    });
  })
  .then(res => res && res.json())
  .then(updated => {
    if (updated) console.log('Cart updated:', updated);
    setTimeout(() => document.dispatchEvent(new Event("cart:refresh")), 500);
  })
  .catch(err => console.error(err));


let cart_busy_timer;

document.addEventListener("cart:change", (event) => {
  window.cart_data = event.detail.cart;
  console.log("change data", event);

  clearTimeout(cart_busy_timer);

  cart_busy_timer = setTimeout(async () => {
    const mysteryIds = new Set([
      52305398366574, // mystery-reaction-item
      41339618918533, // mystery-reaction-movies-tv
      41339618656389, // mystery-reaction-music
      52312692130158, // mystery-blind-box-figure
      52312673288558, // mystery-ultimates-figure
      7250270716037, // mystery_tshirt_id [prod_id]
      7250846711941, // mystery outerwear [prod_id]
      41768019034245 // mystery fun fun
    ]);

    const rand5 = () => Math.floor(Math.random() * 90000) + 10000;

    // --- discounted item updates ---
    const discount_updates = [];
    for (const item of window.cart_data.items) {
      if (
        Array.isArray(item.discounts) && item.discounts.length > 0 &&
        item.properties && typeof item.properties._discounted_price !== "undefined"
      ) {
        const updated_props = { ...item.properties, _discounted_price: item.discounted_price / 100 };
        discount_updates.push(
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: updated_props,
            }),
          })
        );
      }
    }

    // --- mystery item split/remove plan ---
    const re_add_plan = new Map();
    const removalCalls = [];

    for (const item of window.cart_data.items) {
      if (!mysteryIds.has(item.id) && !mysteryIds.has(item.product_id)) continue;

      if (!re_add_plan.has(item.id)) {
        re_add_plan.set(item.id, { count: 0, props: { ...(item.properties || {}) } });
      }
      const entry = re_add_plan.get(item.id);

      console.log("item props", !item.properties["_mystery_id"]);

      if (item.quantity > 1 || !item.properties["_mystery_id"]) {
        // schedule to re-add *only what we removed*
        entry.count += Number(item.quantity || 0);

        removalCalls.push(
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          })
        );
      }
      // qty === 1 lines are left alone, no need to re-add
    }

    if (removalCalls.length === 0) return;

    await Promise.allSettled(removalCalls);

    const itemsToAdd = [];
    for (const [variantId, { count, props }] of re_add_plan.entries()) {
      for (let i = 0; i < count; i++) {
        itemsToAdd.push({
          id: variantId,
          quantity: 1,
          properties: {
            ...props,
            _mystery_id: `${variantId}_${rand5()}_${i + 1}`,
            _mystery_item: "Yes",
          },
        });
      }
    }

    if (itemsToAdd.length === 0) return;

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    setTimeout(() => document.dispatchEvent(new Event("cart:refresh")), 500);
  }, 500); // <--- single debounce delay
});

/*
const apply_tariff_settings = async () => {
  try {
    // Step 1: Set cart attributes
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          _tariff_application: tariff_application,
          _tariff_percentage: tariff_percentage,
          _tariff_title: tariff_title,
          _tariff_var_id: tariff_var_id,
        },
      }),
    });

    // Step 2: Add or update tariff item
    if (!tariff_var_id) return;

    let debounceTimeout;
    const DEBOUNCE_DELAY = 300; // ms
        
    const updateTariffItem = async () => {
      const cart_item_count = document.querySelectorAll(`cart-drawer line-item:not([data-var-id="${tariff_var_id}"])`).length;
      const tariff_item_count = document.querySelectorAll(`cart-drawer line-item[data-var-id="${tariff_var_id}"]`).length;
    
      const cart = await fetch("/cart.js").then(res => res.json());
      const lineItem = cart.items.find(item => item.id.toString() === tariff_var_id);
    
      if (cart_item_count > 0 && tariff_item_count === 0) {
        // Add tariff item
        if (lineItem) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: lineItem.key, quantity: 1 }),
          });
          console.log("Tariff item quantity updated to 1");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        } else {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: tariff_var_id, quantity: 1 }),
          });
          console.log("Tariff item added to cart");
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
    
      } else if (cart_item_count === 0 && tariff_item_count > 0 && lineItem) {
        // Remove tariff item
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lineItem.key, quantity: 0 }),
        });
        console.log("Tariff item removed from cart");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    };

    observeSelector('cart-drawer .cart-drawer__line-items line-item', line_item => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(updateTariffItem, DEBOUNCE_DELAY);
    });

  } catch (err) {
    console.error("Tariff setup failed:", err);
  }
    
};

// Init on load
document.addEventListener("DOMContentLoaded", apply_tariff_settings);
*/

// ---
// START support for [SUP7-66] (and implementation of [SUP7-53]v1)
// ---

/*
window.mystery_discount_percent = .4; // 40%
window.mystery_discount_prop = "[SUP7-66]v1";

// gtm_add_cartAttribute("proteus-experimentation-sup7-53", "[SUP7-53]v2")
if(!window.sessionStorage.getItem("default checkout upsell set")){
  // set just once per session
  setTimeout(() => {
    gtm_add_cartAttribute("proteus_checkout_upsell", window.mystery_discount_prop)
    window.sessionStorage.setItem("default checkout upsell set", true)
  }, 3500)
}
*/

window.mystery_discount_percent = .4; // 40%
window.mystery_discount_prop = "[SUP7-66]v1";


    let random_id = () => {
        return Math.floor(Math.random() * 90000) + 10000;
    };

    if(window.location.href.indexOf("cart=open") > -1){
      waitUntil(() => {
          return document.querySelectorAll('.js__cart-expand').length > 0 && document.querySelectorAll('.js__cart-table-item-row').length > 0;
      }).then(() => {
          let cart_trigger = document.querySelector('.js__cart-expand');
          cart_trigger.click();
      }).catch();
    }

    observeSelector('line-item[data-var-id]', line_item => {

      if(typeof window.mystery_item != "undefined"){
        // const atc_url = `https://super7.com/cart/add?items[][id]=${mystery_item.var_id}&items[][quantity]=1&items[][properties][_free-gift]=true&return_to=${window.location.pathname}?cart=open`;
        const atc_url = `https://super7.com/cart/add?items[][id]=${mystery_item.var_id}&items[][quantity]=1&items[][properties[_mystery_id]]=${random_id()}&items[][properties[_mystery_item]]=yes&items[][properties[_discount]]=${mystery_discount_prop}&return_to=${window.location.pathname}?cart=open`;

          // if(document.querySelectorAll(`line-item[data-var-id="${mystery_item.var_id}"]`).length == 0 &&)
          if(document.querySelectorAll(`.js-mystery-item--atc`).length == 0){

              // if the ATC module does not exist and item IS NOT in the cart
              line_item.parentNode.insertAdjacentHTML("afterbegin", `

              <div class="horizontal-product rounded-xs bg-custom js-mystery-item--atc" style="--background: 242 242 242; order: 1; width: 100%;">
                  <img src="${mystery_item.image_url}" class="horizontal-product__image rounded-xs" />
                  <div class="horizontal-product__info">
                      <div class="v-stack gap-0.5">
                          <div class="text-sm">
                          <span class="reversed-link bold h4">${mystery_item.title}</span>
                          <p class="product-subtitle mystery" style="font-size: 12px;">It could be a limited release, glow-in-the-dark, or even an exclusive that isn't available online. You never know what you'll get!</p>
                          <style>
                          @media screen and (max-width: 768px) {
                              .product-subtitle.mystery {
                                  font-size: 10px!important;
                              }
                          }
                          </style>
                      </div>
                  </div>
                  <div style="display:flex; display: flex; justify-content: space-between !important; width: 100%; align-items: baseline;">
  <price-list class="price-list" style="display:flex; gap:.5rem; align-items:baseline;">
    <sale-price class="text-subdued text-sm" style="color:red;">
      <span class="sr-only">Sale price</span>$${(parseFloat(mystery_item.price.replace(/[^0-9.]/g, "")) * (1 - mystery_discount_percent)).toFixed(2)}
    </sale-price>
    <span class="text-sm"><s>${mystery_item.price}</s></span>
  </price-list>


                          <div class="horizontal-product__cta">
                              <form method="post" action="/cart/add" id="complementary-product-sections--15430656458885__cart-drawer--7124329136261" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form" data-product-tags="">
                  
                                  <input type="hidden" name="form_type" value="product">
                                  <input type="hidden" name="utf8" value="✓">
                                  <input type="hidden" name="quantity" value="1">
                                  <input type="hidden" name="id" value="${mystery_item.var_id}">
                                  <input type="hidden" name="properties[_mystery_id]" value="${random_id()}">
                                  <input type="hidden" name="properties[_mystery_item]" value="yes">
                                  <input type="hidden" name="properties[_discount]" value="${mystery_discount_prop}">

                                  <button type="submit" class="button button--sm button--subdued" is="custom-button"><div>Add One!</div><span class="button__loader"><span></span><span></span><span></span></span></button>
                  

                              </form>
                              <form class="mystery-buy-three" style="display:important;margin-top:5px;" method="post" action="/cart/add" id="complementary-product-sections--15430656458885__cart-drawer--7124329136261" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form" data-product-tags="">
                  
                                  <input type="hidden" name="form_type" value="product">
                                  <input type="hidden" name="utf8" value="✓">
                                  <input type="hidden" name="quantity" value="3">
                                  <input type="hidden" name="id" value="${mystery_item.var_id}">
                                  <input type="hidden" name="properties[_mystery_id]" value="${random_id()}">
                                  <input type="hidden" name="properties[_mystery_item]" value="yes">
                                  <input type="hidden" name="properties[_discount]" value="${mystery_discount_prop}">

                                  <button type="submit" class="button button--sm button--primary" is="custom-button"><div>Add Three!</div><span class="button__loader"><span></span><span></span><span></span></span></button>
                  

                              </form>
                          </div>
                      </div>
                  </div>
              </div>
      
              `);
          } else {
              // update random_id
              console.log(`update random_id -- ${random_id()}`)
              document.querySelector('.js-mystery-item--atc input[name="properties[_mystery_id]"]').value = random_id();
          }

      } // window.mystery_item != "undefined"
    });

// ---
// END support for [SUP7-66] (and implementation of [SUP7-53]v1)
// ---
